module.exports = __webpack_public_path__ + "static/img/search_no.5378d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search_no.png
// module id = Yin0
// module chunks = 1